import React, {Component} from 'react';
import compose from 'recompose/compose';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import {
	changeCurrentPath,
	fetchDeliveryStatusDetail,
	getPdfItemsDeliveryStatus,
	clearPdfItemsDeliveryStatus,
	fetchCsvDataDeliveryStatus,
	resetDeliveryStatusDetailState,
	getPdfItemsDeliveryStatusSecom,
	getPdfItemsDeliveryStatusMod,
	clearPdfItemsDeliveryStatusMod,
	clearPdfItemsDeliveryStatusSecom, resetDeliveryStatusListState
} from '../../actions';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import SpNav from '../../common/containers/sp_nav'
import Footer from '../../common/containers/footer';

import ErrorDialog from '../../common/components/dialog/error-dialog';
import ReloadModal from '../../common/components/dialog/reload-dialog';
import LogoutModal from '../../common/components/dialog/logout-dialog';
import MainButtons from '../../common/components/main-buttons';
import Tables from '../../common/components/table/common-table';


import PdfViewer from '../../common/components/viewer/pdf-viewer';
import StepDialog from "./components/step-dialog";
import PropTypes from "prop-types";


const columns = [
	{name: 'DeliveryStatus', title: 'ステータス', width: 150},
	{name: 'NohinYoteiYMD', title: '納品日', width: 150},
	{name: 'OtodokesakiName', title: '納品先名称', width: 200},
	{name: 'ButsuryuBotenName', title: '物流母店名称', width: 200},
	{name: 'NouhinJigyoushaName', title: '納品事業者名称', width: 200},
	{name: 'CarNumber', title: '車番', width: 100},
	{name: 'NinushiName', title: '荷主名称', width: 200},
	{name: 'DenpyoNO', title: '伝票番号', width: 150},
	{name: 'ReceiptStatusName', title: '受領結果', width: 100},
	{name: 'DeliveryStatusButton', title: '配送状況', width: 100, sortingEnabled: false, filteringEnabled: false},
];

const numberColumns = [];

const styles = theme => ({
	datePicker: {
		marginTop: '-10px',
		width: '150px'
	},
	fromTo: {
		padding: '0 15px',
		fontSize: '1.5rem',
		fontFamily: "Roboto, Helvetica, Arial, sans-serif",
	},
	heading: {
		fontSize: theme.typography.pxToRem(15),
	},
	expands: {
		boxShadow: 'initial'
	}
});

const DLMaxCount = 5000;
const PrintMaxCount = 1000;

class DeliveryStatusDetail extends Component {

	constructor(props) {
		super(props);
		this.state = {
			rows: [],
			selection: [],
			sorts: [{columnName: 'DenpyoNO', direction: 'asc'}],
			dialogOpen: false,
			updateSelections: [],
			headerSelections: [],
			headerDateType: "1",
			headerSelectedDateFrom: null,
			headerSelectedDateTo: null,
			selectionDetailCount: 0,
			showDlErrorDialog: false,
			receiptPdfUrl: null,
			isStepperOpen: false,
			stepperStatus: [
				'',
				'',
				'',
				''
			],
			stepperNinushiName: '',
			stepperDenpyoNO: '',
			stepperNohinYoteiYMD: ''
		}

		this.nextIsMain = false;

	}

	/** override methods **/
	UNSAFE_componentWillMount() {
		const {dispatch, settings} = this.props;
		const {dateType, selectedDateFrom, selectedDateTo} = settings;

		const selections = settings.selections.map(selection => {
			return selection["id"];
		});
		this.setState({
			headerSelections: selections,
			headerDateType: dateType,
			headerSelectedDateFrom: selectedDateFrom,
			headerSelectedDateTo: selectedDateTo
		});
		const SessionID = this.props.auth.SessionID;
		dispatch(fetchDeliveryStatusDetail({
			selections,
			SessionID
		}));
	}

	componentDidMount() {
		const {dispatch, history} = this.props;
		window.scrollTo(0, 0);
		dispatch(changeCurrentPath({currentPath: history.location.pathname}));
	}

	componentWillUnmount() {
		const {dispatch} = this.props;
		dispatch(resetDeliveryStatusDetailState());
		if (!this.nextIsMain) {
			dispatch(resetDeliveryStatusListState());
		}
	}


	/** event handlers **/
	handleSelectionChange = selection => {
		let selectionDetailCount = 0;
		selection.forEach((row) => {
			selectionDetailCount += isNaN(row.DetailCount) ? 0 : row.DetailCount;
		});
		this.setState({
			selection,
			selectionDetailCount
		});
	};

	handleSortsChange = sorts => {
		this.setState({sorts});
	}


	handleClickDL = event => {

		if (this.state.selectionDetailCount > DLMaxCount) {
			this.setState({
				showDlErrorDialog: true
			});
			return;
		}

		const {dispatch} = this.props;
		const DetailIDs = this.state.selection.map(selection => {
			return selection["id"];
		});
		dispatch(fetchCsvDataDeliveryStatus({
			DetailIDs,
			process_divide: 1,
			SessionID: this.props.auth.SessionID
		}));

	};

	handleClickBack = event => {
		this.nextIsMain = true;
		this.props.history.push('/delivery-status-list');
	};

	handleClickSlipNo = (row) => {
		const {dispatch, auth} = this.props;
		const selections = [row["id"]];
		this.setState({
			updateSelections: selections
		});
		dispatch(getPdfItemsDeliveryStatus({
			selections,
			SessionID: auth.SessionID
		}));

	};

	handleClickReceiptPdf = (row) => {
		if (row.HasSecomPdf === "1") {
			const selections = [row["id"]];
			this.props.dispatch(getPdfItemsDeliveryStatusSecom({
				selections,
				SessionID: this.props.auth.SessionID,
				UploadAreaCD: row.UploadAreaCD,
				UploadFileName: row.UploadFileName,
				UploadDirectoryNO: row.UploadDirectoryNO,
				ReceiptPdfPath: row.ReceiptPdfPath,
			}));
		} else if (row.ReceiptPdfPath) {
			this.setState({
				receiptPdfUrl: row.ReceiptPdfPath
			});
		} else if (row.ReceiptSignPath) {
			const selections = [row["id"]];
			this.props.dispatch(getPdfItemsDeliveryStatusMod({
				selections,
				SessionID: this.props.auth.SessionID
			}));
		} else {
			this.setState({
				receiptPdfUrl: row.UploadPdfPath
			});
		}
	}

	handleClickStatus = (row) => {
		console.log(row)
		this.setState({
			isStepperOpen: true,
			stepperStatus: [
				row.HaisoStatus || '',
				row.UketsukeStatus || '',
				row.YobidashiStatus || '',
				row.KanryoStatus || ''
			],
			stepperNinushiName: row.NinushiName || '',
			stepperDenpyoNO: row.DenpyoNO || '',
			stepperNohinYoteiYMD: row.NohinYoteiYMD || ''
		})
	}

	handleCloseStepper = () => {
		this.setState({
			isStepperOpen: false,
			stepperStatus: ['', '', '', ''],
			stepperNinushiName: '',
			stepperDenpyoNO: '',
			stepperNohinYoteiYMD: ''
		})
	}

	afterCloseFunc = () => {
		const {dispatch} = this.props;
		dispatch(clearPdfItemsDeliveryStatus());
	};

	afterCloseModFunc = () => {
		const {dispatch} = this.props;
		dispatch(clearPdfItemsDeliveryStatusMod());
	};

	afterCloseSecomFunc = () => {
		const {dispatch} = this.props;
		dispatch(clearPdfItemsDeliveryStatusSecom());
	}

	afterCloseFuncReceiptSlips = () => {
		this.setState({
			receiptPdfUrl: null
		});
	};

	handleCloseDlError = () => {
		this.setState({
			showDlErrorDialog: false
		});
	};


	render() {
		const {
			settings, auth
		} = this.props;
		const {
			selection, receiptPdfUrl,
			selectionDetailCount, showDlErrorDialog,
			sorts
		} = this.state;

		const rows = settings.data;
		const disabled = !(selection.length);

		const {JigyoushaIsMaker, JigyoushaIsNohinJigyousha, JigyoushaIs3PL} = auth.user;
		const isMaker = JigyoushaIsMaker && !JigyoushaIsNohinJigyousha && !JigyoushaIs3PL;

		let mainButtons = [];
		if (isMaker) {
			mainButtons = [
				{type: 'DL', func: this.handleClickDL, disabled: disabled},
				{type: 'BACK', func: this.handleClickBack, text: "一覧", hasMargin: true}
			];
		} else {
			mainButtons = [
				{type: 'DL', func: this.handleClickDL, disabled: disabled},
				{type: 'BACK', func: this.handleClickBack, text: "一覧", hasMargin: true}
			];
		}


		const clickableColumns = [
			{name: 'DenpyoNO', func: this.handleClickSlipNo},
			{name: 'ReceiptStatusName', func: this.handleClickReceiptPdf},
			{name: 'DeliveryStatusButton', func: this.handleClickStatus, type: 'button', text: '状況'}
		];

		const printDialogOpen = (settings.pdfPath !== undefined);
		const printDialogModOpen = (settings.pdfPathMod !== undefined);
		const printDialogSecomOpen = (settings.pdfPathSecom !== undefined);

		const limitText = <span>対象データが大きいため、期間や荷主などでデータを絞り込んで下さい<br/>
			<br/>
			現在の選択件数 : {selectionDetailCount}<br/>
			※同時DL可能上限 : {DLMaxCount}件(明細数)</span>;

		const limitText2 = <span>対象データが大きいため、期間や荷主などでデータを絞り込んで下さい<br/>
			<br/>
			現在の選択件数 : {selection.length}<br/>
			※同時印刷可能上限 : {PrintMaxCount}件(伝票数)</span>;

		return (
			<div id="main_container">
				{settings.isFetching &&
				<Progress/>
				}
				<SpNav history={this.props.history}/>
				<Header history={this.props.history}/>
				<article>
					<section className="title_area">
						<h2>納品状況照会<span>詳細</span></h2>
					</section>
					<section className="with_button">
						<Tables
							dataSource={rows}
							columns={columns}
							numberColumns={numberColumns}
							clickableColumns={clickableColumns}
							getSelections={this.handleSelectionChange}
							getSortOrders={this.handleSortsChange}
							defaultSorts={sorts}
							selections={selection}
						/>
					</section>
				</article>
				<MainButtons buttons={mainButtons}/>
				<Footer/>
				{printDialogOpen &&
				<PdfViewer
					filePath={settings.pdfPath}
					afterCloseFunc={this.afterCloseFunc}
				/>
				}
				{printDialogModOpen &&
				<PdfViewer
					filePath={settings.pdfPathMod}
					afterCloseFunc={this.afterCloseModFunc}
				/>
				}
				{receiptPdfUrl &&
				<PdfViewer
					filePath={receiptPdfUrl}
					afterCloseFunc={this.afterCloseFuncReceiptSlips}
				/>
				}
				{printDialogSecomOpen &&
				<PdfViewer
					filePath={settings.pdfPathSecom}
					afterCloseFunc={this.afterCloseSecomFunc}
				/>
				}
				<ErrorDialog
					open={showDlErrorDialog}
					title={'利用制限'}
					text={limitText}
					afterCloseFunc={this.handleCloseDlError}
				/>
				<ErrorDialog
					open={this.props.settings.isProcessError}
				/>
				<ReloadModal/>
				<LogoutModal/>
				<StepDialog
					open={this.state.isStepperOpen}
					onClose={this.handleCloseStepper}
					status={this.state.stepperStatus}
					DenpyoNO={this.state.stepperDenpyoNO}
					NohinYoteiYMD={this.state.stepperNohinYoteiYMD}
					NinushiName={this.state.stepperNinushiName}
				/>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation: state.navigation,
		auth: state.auth,
		settings: state.deliveryStatusDetailSettings
	};
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(DeliveryStatusDetail);



// WEBPACK FOOTER //
// ./src/routes/delivery-status-detail/index.js